import { DefaultLogic } from './default';
import { MealDeliveryLogic } from './verticals/meal-delivery';
import { WeightlossLogic } from './verticals/weightloss';

const verticals = {
    MATCH_MAKING: 1,
    SPEED_BOAT: 3,
    DATING: 8,
    MEAL_DELIVERY: 10,
    WEIGHT_LOSS: 19,
};

let templateLogic = null;

function makeTemplateLogic() {
    switch (window.__host__.project_id) {
        case verticals.MEAL_DELIVERY:
            return new MealDeliveryLogic();
        case verticals.WEIGHT_LOSS:
            return new WeightlossLogic();
        case verticals.DATING:
        case verticals.SPEED_BOAT:
        case verticals.MATCH_MAKING:
            return new DefaultLogic();
    }

    return new DefaultLogic();
}

export function getTemplateLogic() {
    if (!templateLogic) {
        templateLogic = makeTemplateLogic();
    }

    return templateLogic;
}
